module.exports = __webpack_public_path__ + "media/images/preview_recipe_1_thumb-1c908c5f61d73ccf140b1ef2bfe28a62.webp";